import React, { useMemo } from 'react';
import { IRowMeta } from '../../../../redux/slices/oldBuilder';
import {
  builderSelectedOptionsSelector,
  funnelOrdersSelector,
} from '../../../../redux/selectors/builder';
import {
  FunnelOrderKey,
  QueryType,
} from '../../../../utils/apollo/graphqlSchema';
import { funnelOrderTooltips } from '../../../KubitTooltip/globalTooltips';
import { useAppSelector } from '../../../../redux/hooks';
import { assertCondition, assertNotNil } from '../../../../utils/types';
import BuilderStepCustomOrder from './BuilderStepCustomOrder';
import { ConnectorContainer, ConnectorWrapper } from '../../BuilderUI';
import KubitTooltip from '../../../KubitTooltip';

interface IProps {
  rowMeta: IRowMeta;
}

const BuilderStepOrder = ({ rowMeta }: IProps) => {
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );
  const defaultFunnelOrders = useAppSelector(funnelOrdersSelector);

  assertCondition(selectedOptions?.type === QueryType.Funnel);
  const { funnelOrder: selectedFunnelOrder } = selectedOptions;

  const label = useMemo(() => {
    if (selectedFunnelOrder === FunnelOrderKey.Any) {
      return 'Any order';
    }

    const name = defaultFunnelOrders.find(
      (order) => order.key === selectedFunnelOrder,
    )?.name;
    assertNotNil(name);

    return name;
  }, [defaultFunnelOrders, selectedFunnelOrder]);

  if (selectedFunnelOrder === FunnelOrderKey.Custom) {
    return (
      <ConnectorContainer>
        <BuilderStepCustomOrder rowMeta={rowMeta} />
      </ConnectorContainer>
    );
  }

  return (
    <ConnectorContainer>
      <KubitTooltip {...funnelOrderTooltips[selectedFunnelOrder]}>
        <ConnectorWrapper>{label}</ConnectorWrapper>
      </KubitTooltip>
    </ConnectorContainer>
  );
};

export default BuilderStepOrder;
